import { render, staticRenderFns } from "./poster.vue?vue&type=template&id=58079ea8"
import script from "./poster.vue?vue&type=script&lang=js"
export * from "./poster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports